import { createHeaders, withReThrowingDataServiceError, } from './data-service-api';
import axios from 'axios';
export class DataServiceDialectsApiClient {
    constructor(baseUrl, tokenProvider) {
        this.baseUrl = baseUrl;
        this.tokenProvider = tokenProvider;
    }
    async markAsRead(dialectPublicKey) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .post(`${this.baseUrl}/api/v1/dialects/${dialectPublicKey}/markAsRead`, {}, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    // async patchMember(
    //   dialectPublicKey: string,
    //   command: PatchMemberCommandDto,
    // ): Promise<MemberDto> {
    //   const token = await this.tokenProvider.get();
    //   return withReThrowingDataServiceError(
    //     axios
    //       .patch<MemberDto>(
    //         `${this.baseUrl}/api/v1/dialects/${dialectPublicKey}/members/me`,
    //         command,
    //         {
    //           headers: createHeaders(token),
    //         },
    //       )
    //       .then((it) => it.data),
    //   );
    // }
    async create(command) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .post(`${this.baseUrl}/api/v1/dialects`, command, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    async findAll(query) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/api/v1/dialects`, {
            headers: createHeaders(token),
            ...(query && { params: query }),
        })
            .then((it) => it.data));
    }
    async find(publicKey) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/api/v1/dialects/${publicKey}`, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    async delete(publicKey) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .delete(`${this.baseUrl}/api/v1/dialects/${publicKey}`, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    async sendMessage(publicKey, command) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .post(`${this.baseUrl}/api/v1/dialects/${publicKey}/messages`, command, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    findSummary(query) {
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/api/v1/dialects/summary`, {
            headers: createHeaders(),
            ...(query && { params: query }),
        })
            .then((it) => it.data));
    }
    findSummaryAll(query) {
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/api/v1/dialects/summary/all`, {
            headers: createHeaders(),
            params: query,
        })
            .then((it) => it.data));
    }
}
export var MemberScopeDto;
(function (MemberScopeDto) {
    MemberScopeDto["ADMIN"] = "ADMIN";
    MemberScopeDto["WRITE"] = "WRITE";
})(MemberScopeDto || (MemberScopeDto = {}));
//# sourceMappingURL=data-service-dialects-api.js.map